import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import 'highlight.js/styles/vs.css'
import 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin"
import { startActiveSessionRefresh } from "./auth.js";

const app = createApp(App);
app.use(Quasar, quasarUserOptions);
app.use(hljsVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);
startActiveSessionRefresh();
window.addEventListener("auth-expired", () => {
    if (router.currentRoute.value.meta.requiresAuth) {
        router.replace({ name: "login" });
    }
});
app.mount('#app');